import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsCountertopSearchText = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.countertop.searchText;

export const searchText = setCalculationModeAdminSettingsCountertopSearchText(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_COUNTERTOP_SEARCH_TEXT',
  ''
);
